import { isValidValue } from "utils";


export const setTagIcon = (el = {}) => ({
  createdAt: el.CreatedAt || null,
  updatedAt: el.UpdatedAt || null,
  deletedAt: el.DeletedAt || null,
  id: el.ID || null,
  icon_url: el.icon_url || null,
  color: el.color || null,
  name: el.name || null,
});

export const setTag = (el = {}) => {
  let icon = null;
  if (isValidValue(el.icon)) {
    icon = setTagIcon({ ...el.icon, name: el.name });
  }

  return {
    createdAt: el.CreatedAt || null,
    updatedAt: el.UpdatedAt || null,
    deletedAt: el.DeletedAt || null,
    id: el.ID || null,
    district_id: el.district_id || null,
    name: el.name || null,
    directory_attribute: el.directory_attribute || null,
    description: el.description || null,
    shared_assets_access: el.shared_assets_access || false,
    map_view_access: el.map_view_access || false,
    talk_to_all: el.talk_to_all || false,
    gun_carrier: el.gun_carrier || false,
    is_system_generated: el.is_system_generated || false,
    cpo: el.cpo || false,
    sro: el.sro || false,
    icon_id: el.icon_id || null,
    user_ids: el.user_ids || [],
    tags: icon,
  };
};
